var _path;

var _excluded = ["svgRef", "title"];

function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

import React from "react";

var SvgHtml = function SvgHtml(_ref) {
  var svgRef = _ref.svgRef,
      title = _ref.title,
      props = _objectWithoutProperties(_ref, _excluded);

  return /*#__PURE__*/React.createElement("svg", _extends({
    fill: "#000000",
    viewBox: "-50 -90 700 700",
    width: "500px",
    height: "500px",
    ref: svgRef
  }, props), title ? /*#__PURE__*/React.createElement("title", null, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M278.9,511.5L217.9,493.8C211.5,492 207.9,485.3 209.7,478.9L346.2,8.7C348,2.3 354.7,-1.3 361.1,0.5L422.1,18.2C428.5,20 432.1,26.7 430.3,33.1L293.8,503.3C291.9,509.7 285.3,513.4 278.9,511.5ZM164.9,399.3L208.4,352.9C213,348 212.7,340.2 207.6,335.7L117,256L207.6,176.3C212.7,171.8 213.1,164 208.4,159.1L164.9,112.7C160.4,107.9 152.8,107.6 147.9,112.2L3.8,247.2C-1.3,251.9 -1.3,260 3.8,264.7L147.9,399.8C152.8,404.4 160.4,404.2 164.9,399.3ZM492.1,399.9L636.2,264.8C641.3,260.1 641.3,252 636.2,247.3L492.1,112.1C487.3,107.6 479.7,107.8 475.1,112.6L431.6,159C427,163.9 427.3,171.7 432.4,176.2L523,256L432.4,335.7C427.3,340.2 426.9,348 431.6,352.9L475.1,399.3C479.6,404.2 487.2,404.4 492.1,399.9Z"
  })));
};

var ForwardRef = /*#__PURE__*/React.forwardRef(function (props, ref) {
  return /*#__PURE__*/React.createElement(SvgHtml, _extends({
    svgRef: ref
  }, props));
});
export default __webpack_public_path__ + "static/media/html.0a26425b.svg";
export { ForwardRef as ReactComponent };